import { useMemo } from "react";

/**
 * Sorts items by placing prioritized ones at the beginning of the list.
 * @param allItems All items to sort
 * @param priorityItems Items that should appear first
 */
export const usePrioritizedItems = <T>(allItems: T[], priorityItems: T[]): T[] => {
  return useMemo(() => {
    const prioritized: T[] = [];
    const regular: T[] = [];

    allItems.forEach((item) => {
      if (priorityItems.includes(item)) {
        prioritized.push(item);
      } else {
        regular.push(item);
      }
    });

    return [...prioritized, ...regular];
  }, [allItems, priorityItems]);
};
